import type { WidgetMountOptions } from '../types/config';
import type { WidgetEventName, WidgetEventPayload } from '../types/events';
import type {
  WidgetMethodSelectionResponse,
  WidgetPaymentStatusResponse,
  WidgetSessionResponse
} from '../types/state';

function nowIso(): string {
  return new Date().toISOString();
}

export class WidgetEventsBus {
  constructor(private readonly options: WidgetMountOptions) {}

  emit(
    event: WidgetEventName,
    payload?: Partial<WidgetEventPayload> & {
      session?: WidgetSessionResponse | null;
      selection?: WidgetMethodSelectionResponse | null;
      statusPayload?: WidgetPaymentStatusResponse | null;
    }
  ): void {
    const session = payload?.session ?? null;
    const selection = payload?.selection ?? null;
    const statusPayload = payload?.statusPayload ?? null;

    const eventPayload: WidgetEventPayload = {
      event,
      projectId: session?.projectId ?? payload?.projectId ?? null,
      paymentUuid:
        statusPayload?.paymentUuid ??
        selection?.paymentUuid ??
        session?.paymentUuid ??
        payload?.paymentUuid ??
        null,
      merchantOrderId:
        statusPayload?.merchantOrderId ??
        session?.merchantOrderId ??
        this.options.merchantOrderId,
      status:
        statusPayload?.status ??
        selection?.status ??
        session?.status ??
        payload?.status ??
        null,
      network: statusPayload?.network ?? selection?.network ?? payload?.network ?? null,
      asset: statusPayload?.asset ?? selection?.asset ?? payload?.asset ?? null,
      paymentMethod:
        statusPayload?.paymentMethod ?? selection?.paymentMethod ?? payload?.paymentMethod ?? null,
      expectedAmount:
        statusPayload?.expectedAmount ?? selection?.expectedAmount ?? payload?.expectedAmount ?? null,
      receivedAmount:
        statusPayload?.receivedAmount ?? selection?.receivedAmount ?? payload?.receivedAmount ?? null,
      currentConfirmations:
        statusPayload?.currentConfirmations ?? selection?.currentConfirmations ?? payload?.currentConfirmations ?? 0,
      confirmationsRequired:
        statusPayload?.confirmationsRequired ??
        selection?.confirmationsRequired ??
        payload?.confirmationsRequired ??
        0,
      txHash: statusPayload?.txHashes?.[0] ?? payload?.txHash ?? null,
      timestamp: nowIso(),
      meta: this.options.meta
    };

    this.options.onEvent?.(eventPayload);
  }
}